"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePaymentDetails = void 0;
var kapi_1 = require("../../../shared/api/kapi");
var legacy_queries_1 = require("../../../shared/api/legacy-queries");
var core_1 = require("../../../shared/core");
var mapping_1 = require("./mapping");
var usePaymentDetails = function (_a) {
    var accountId = _a.accountId;
    var retailer = core_1.configService.getConfig().retailer;
    var kapiEnabled = retailer.region === 'AUS';
    var _b = (0, kapi_1.usePaymentDetailsQuery)({
        variables: {
            accountId: accountId,
        },
        skip: !kapiEnabled,
    }), kapiData = _b.data, kapiLoading = _b.loading, kapiError = _b.error;
    var directDebitLegacyQueryResult = (0, legacy_queries_1.useDirectDebitLegacyQuery)(accountId, {
        enabled: !kapiEnabled,
    });
    var legacyLoading = directDebitLegacyQueryResult.isFetching;
    var legacyError = directDebitLegacyQueryResult.status === 'error' ? mapping_1.genericError : undefined;
    var data = kapiEnabled && kapiData
        ? (0, mapping_1.mapKapiToPaymentDetailsCX)(kapiData)
        : directDebitLegacyQueryResult.status === 'data'
            ? (0, mapping_1.mapLegacyToPaymentDetailsCX)(directDebitLegacyQueryResult.data)
            : null;
    return {
        loading: kapiLoading || legacyLoading,
        error: (kapiError && (0, mapping_1.mapKapiToPaymentDetailsError)(kapiError)) || legacyError,
        data: data,
    };
};
exports.usePaymentDetails = usePaymentDetails;
